import { Component, Input, OnInit } from '@angular/core';
import { EventManagerService } from 'src/app/core/services/event-manager.service';
import { menuItemHomePage, MENU_PORTAL } from '.';
import { CONTRACT_ROLES, RSP_ROLES, ROLE_NAME, DOCSTORE_ROLES } from '../../enums/admin-enum';
import { LocalService } from '../../service/local.service';
import { ProfileService } from '../../service/profile.service';
import { Spinner } from './../../../core/services/spinner.service';
import { AUTHORIZED, SRM, CONTRACT, DOCSTORE, EOL } from './index';

@Component({
  selector: 'app-layout-header',
  templateUrl: './layout-header.component.html',
  styleUrls: ['./layout-header.component.scss']
})
export class LayoutHeaderComponent implements OnInit {
  @Input() isLandingPage: boolean = false;
  @Input() isContractManagementModule=false;
  userName: string;
  wd = window;
  menuItemHomePage = menuItemHomePage;
  menuPortal = MENU_PORTAL;
  srmMenu = SRM;
  contractMenu = CONTRACT;
  docStoreMenu = DOCSTORE;
  eolMenu = EOL;
  isSRM = false;
  isContract = false;
  isDocStore = false;
  isEOL = false;
  isSupplierHasPermission = false;
  hasDestructionPermission = false;
  hasRecyclingPermission = false;
  isRSP = false;
  roles = [];
  roleName: string;

  constructor(
    private eventManager: EventManagerService,
    private service: LocalService,
    private profileService: ProfileService,
    private spinner: Spinner
  ) {
    this.roles = atob(localStorage.getItem(btoa('role'))).split(',');
    this.roleName = this.roles.map(role => ROLE_NAME[role]).toString();
    this.profileService.getProfileUser().subscribe((res: any) => {
      // this.spinner.hide(); // ???
      if (res && res.data.roles.findIndex(i => i === 'GUEST') === -1) {
        this.userName = res.data.fullName;
        this.isSRM = res.data.authorized.some(i => i === AUTHORIZED.SRM) ? true : false;
        this.isContract = res.data.authorized.some(i => i === AUTHORIZED.CONTRACT)  ? true : false;
        this.isDocStore = res.data.authorized.some(i => i === AUTHORIZED.DOCSTORE)  ? true : false;
        this.isRSP = res.data.authorized.some(i => i === AUTHORIZED.RSP) ? true : false;
        this.isEOL = res.data.roles.some(i => i === RSP_ROLES.SUPER_USER || i === RSP_ROLES.EOL_ADMIN);
        const isSupplier = Array.isArray(res?.data?.roles)
          && res.data.roles.some((i: any) => i === RSP_ROLES.SUPPLIER);
        const eolInfos = res?.data?.eolInfos && res?.data?.eolInfos.length && res?.data?.eolInfos.length > 0 
          ? res.data.eolInfos : [];
        const supplierForm = eolInfos && eolInfos.length && eolInfos.length > 0 ? eolInfos[0]?.supplierForm : null;
        this.hasDestructionPermission = !!(supplierForm && supplierForm.destruction === true);
        this.hasRecyclingPermission = !!(supplierForm && supplierForm.recycling === true);
        this.isSupplierHasPermission = !!(isSupplier && (this.hasDestructionPermission || this.hasRecyclingPermission));
        const isGEAdmin = res.data.roles.some( i => i.includes('GE_TAG_ID_ADMIN')) ? true : false;
        if(isGEAdmin){
          this.menuPortal =  [{
            name: 'Application Request Access',
            url: '/application-catalog',
            redirectTo: 'APPLICATiON_CATALOG'
          }];
        }
        let primaryRole;
        if (res.data.primaryRole === 'CONTRACT') {
          primaryRole = this.roles.filter(r => CONTRACT_ROLES[r])[0]
        } else if (res.data.primaryRole === 'DOCSTORE') {
          primaryRole = this.roles.filter(r => DOCSTORE_ROLES[r])[0]
        } else {
          primaryRole = this.roles.filter(r => RSP_ROLES[r])[0];
        }
        this.roleName = ROLE_NAME[primaryRole];
      }
    });
  }

  ngOnInit() {
  }
  logOut() {
    localStorage.removeItem(btoa('userName'));
    localStorage.removeItem(btoa('role'));
    window.location.href = '/logout';
  }

  contactUs() {
    const btnContactUs = document.getElementById('contact-us');
    const btnOpens = document.getElementsByClassName('bc-minimize-state-idle') as HTMLCollectionOf<HTMLElement>;
    const btnOpen = btnOpens[0];

    if (btnOpen) {
      btnOpen.click();
    } else {
      if (btnContactUs) {
        btnContactUs.click();
      }
    }
  }

  // public goPageWiki() {
  //   this.service.getUrlWiki().subscribe((res) => {
  //     const url = res.data.length ? res.data[0].url : res.data.url;
  //     window.open(url);
  //   });
  // }


  public redirectTo(item) {
    return '/login?redirectTo=' + item;
  }

  public checkHidden(permissions: any[], item?: any) {
    if (item && item.url) {
      if (item.url.indexOf('/eol/destruction') !== -1 && !this.hasDestructionPermission && !this.isEOL) {
        return true;
      }
      if (item.url.indexOf('/eol/recycling') !== -1 && !this.hasRecyclingPermission && !this.isEOL) {
        return true;
      }
    }
    let hidden = true;
    permissions.forEach(item => {
      if (this.roles.findIndex(k => k === item) !== -1) {
        hidden = false;
      }
    });
    return hidden;
  }
}